/*
 * Copyright (c) 2019 brightlamp
 */

import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins;

export default
{
    extends: Line,
    mixins: [reactiveProp],
    props: ['chartData', 'options'],
    watch:
    {
        chartData()
        {
            this.renderChart(this.chartData, this.options)
        }
    }
}